import { useEffect, useRef, useCallback } from 'react';

const useScrollAnimation = () => {
  const observerRef = useRef(null);

  const getObserver = useCallback(() => {
    if (!observerRef.current) {
      observerRef.current = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
      );
    }
    return observerRef.current;
  }, []);

  useEffect(() => {
    return () => observerRef.current?.disconnect();
  }, []);

  const observe = useCallback((el) => {
    if (navigator.userAgent === 'ReactSnap') return;
    if (el) {
      getObserver().observe(el);
    }
  }, [getObserver]);

  return observe;
};

export default useScrollAnimation;
